module.exports = __webpack_public_path__ + "r-v3/img/more.10b49339.svg";